import { uniq } from 'lodash';
import { getConfig, isSupportSystem } from '../config';

export const isMultiManageSite = () =>
  isSupportSystem() && !!getConfig().multiSiteDataSourcesConfig?.length;

export const getFirstManageSite = () => {
  const { deployArea, multiSiteDataSourcesConfig } = getConfig();
  if (multiSiteDataSourcesConfig?.length && isMultiManageSite()) {
    return multiSiteDataSourcesConfig.map((item) => item.key)[0];
  }
  return deployArea;
};

// 获取当前系统管理的站点, 包含当前站点
export const getNeedManageSites = () => {
  const { deployArea, multiSiteDataSourcesConfig } = getConfig();
  if (multiSiteDataSourcesConfig && isMultiManageSite()) {
    return [multiSiteDataSourcesConfig.map((item) => item.key)].flat();
  }
  return [deployArea];
};

export const sortSites = (sites?: string[]) => {
  if (!sites) {
    return;
  }
  const manageSites = getNeedManageSites();
  return sites.sort((a, b) =>
    manageSites.indexOf(a) > manageSites.indexOf(b) ? 1 : -1
  );
};

// 合并显示的页面获取需要除默认站点外其他站点
export const getExtraManageSites = () => {
  const { multiSiteDataSourcesConfig = [] } = getConfig();
  if (isMultiManageSite()) {
    return multiSiteDataSourcesConfig
      .filter((item) => item.key !== multiSiteDataSourcesConfig[0].key)
      .map((item) => item.key);
  }
  return [];
};

// 需要包含当前管理的站点和同步站点
export const getNeedManageSitesWithSync = () => {
  const {
    deployArea,
    multiSiteDataSourcesConfig = [],
    multiSiteDataSyncConfig = [],
  } = getConfig();
  if (isMultiManageSite()) {
    return uniq(
      [...multiSiteDataSyncConfig, ...multiSiteDataSourcesConfig].map(
        (item) => item.key
      )
    );
  }
  return [deployArea];
};

export const getNeedSynSiteOptions = () => {
  const { multiSiteDataSyncConfig = [] } = getConfig();

  return multiSiteDataSyncConfig.map((item) => {
    return {
      label: `${getSiteText(item.key)}(${item.domain})`,
      value: item.key,
      deployRegion: item.deployRegion,
    };
  });
};

const getSiteNameMap = (): Record<string, string> => {
  const { multiSiteDataSourcesConfig = [], multiSiteDataSyncConfig = [] } =
    getConfig();

  return [...multiSiteDataSourcesConfig, ...multiSiteDataSyncConfig].reduce<
    Record<string, string>
  >((acc, item) => {
    const { key } = item;
    acc[key] = item.name;
    return acc;
  }, {});
};

export const getSiteText = (site?: string) => {
  if (!site) {
    return getSiteNameMap()[getFirstManageSite()] || '';
  }

  return getSiteNameMap()[site] || '';
};

export const getSiteOptions = () => {
  return getNeedManageSites().map((siteItem) => {
    return {
      label: getSiteText(siteItem),
      value: siteItem,
    };
  });
};

export const getSiteDomain = (site = '') => {
  const { multiSiteDataSourcesConfig, multiSiteDataSyncConfig = [] } =
    getConfig();
  if (!multiSiteDataSourcesConfig) {
    return '';
  }
  return (
    [...multiSiteDataSourcesConfig, ...multiSiteDataSyncConfig].find(
      (item) => item.key === site
    )?.domain || ''
  );
};

export const isSplitSitePage = () => {
  const splitSitePaths = [
    'user',
    'game-list',
    'close-open',
    'service',
    'mail-record',
    'message',
    'price-calculator',
    'fee',
    'app-config',
    'permission',
    'company-auth',
    'download-record',
  ];
  return (
    isMultiManageSite() &&
    splitSitePaths.some((item) =>
      location.pathname.startsWith(`/admin/${item}`)
    )
  );
};
